import React, { createContext, useContext, useMemo } from 'react';

const TenantPathContext = createContext({ tenantId: null, prefix: '' });

export function TenantPathProvider({ tenantId, children }) {
  const value = useMemo(
    () => ({ tenantId: tenantId || null, prefix: tenantId ? `/${tenantId}` : '' }),
    [tenantId]
  );
  return <TenantPathContext.Provider value={value}>{children}</TenantPathContext.Provider>;
}

export function useTenantPath() {
  return useContext(TenantPathContext);
}
